<template>
  <el-container class="index-con">
    <el-aside :class="showclass">
      <leftnavs style="height: 100%;"></leftnavs>
    </el-aside>
    <el-container class="main-con">
      <el-header
        class="index-header"
        style="text-align: right; font-size: 12px; border: none"
      >
        <navcon></navcon>
      </el-header>
      <el-main clss="index-main">
        <router-view v-if="isRouterAlive"></router-view>   
      </el-main>
          <el-footer class="footer">Powered by 舒誉</el-footer>
    </el-container>
  </el-container>
</template>
<script>
// 导入组件
import navcon from "../components/navcon.vue";
import leftnavs from "../components/leftnav.vue";
export default {
  name: 'index',
  data() {
    return {
      ruleForm: "",
      dialogTableVisible: true,
      showclass: "asideshow",
      showtype: false,
      isRouterAlive: true,
    };
  },
  provide() {
    return {
      reload: this.reload,
    };
  },
  // 注册组件
  components: {
    navcon,
    leftnavs,
  },
  methods: {
    reload() {
      this.isRouterAlive = false;
      this.$nextTick(function () {
        this.isRouterAlive = true;
      });
    },
  },
  created() {
  },
  beforeUpdate() {},
  // 挂载前状态(里面是操作)
  beforeMount() {
    // 弹出登录成功
    // this.$message({
    //   message: "登录成功",
    //   type: "success",
    // });
  },
};
</script>
<style >
.footer{
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
font-family: PingFang SC;
font-weight: 400;
height: 50px !important;
color: #666666;
}
 .el-table /deep/.DisabledSelection .cell .el-checkbox__inner{
    margin-left: -30px;
    position:relative;
  }
  .el-table /deep/.DisabledSelection .cell:before{
    content:"全选";
    position:absolute;
    right:11px;
  }
input {
  outline: none !important;
}
.el-menu-item { 
  /* font-size: 16px !important; */
}
.el-submenu__title {
  /* font-size: 16px !important; */
}
.el-dialog__body {
  /* padding: 0 !important; */
}
.el-pagination.is-background .btn-next,
.el-pagination.is-background .btn-prev,
.el-pagination.is-background .el-pager li {
  background-color: transparent;
}
.el-pagination.is-background .el-pager li:not(.disabled).active {
  background-color: #5178ff !important;
}

.paging_box {
  margin-top: 22px;
  display: flex;
  justify-content: flex-end;
}
.el-menu.el-menu--horizontal {
  border: none;
}
.content_box {
  width: 100%;
  height: auto;
  background: #ffffff;
  padding: 38px 30px;
  margin-bottom: 12px;
  box-sizing: border-box;
}
.index-con {
  height: 100%;
  width: 100%;
  box-sizing: border-box;
}

.aside {
  width: 64px !important;
  height: 100%;
  background-color: #fff;
  margin: 0px;
}
.asideshow {
  width: 200px !important;
  height: 100%;
  background-color: #fff;
  margin: 0px;
}
.el-main {
  padding: 12px 14px;
  box-sizing: border-box;
}
.index-header,
.index-main {
  padding: 0px;

  /* border-left: 2px solid #333; */
}
.content_box_title {
  display: flex;
  align-items: center;
}
.circle_l {
  width: 18px;
  height: 18px;
  background: #5178ff;
  border-radius: 50%;
}
.circle_r {
  width: 18px;
  height: 18px;
  background: rgba(81, 120, 255, 0.27);
  border-radius: 50%;
  margin-left: -7px;
}
.text_xl {
  font-size: 20px;
  font-family: PingFang SC;
  font-weight: bold;
  margin-left: 20px;
  color: #333333;
}
</style>



// WEBPACK FOOTER //
// src/views/index.vue